$(function () {
    $('.product-preview-slide').owlCarousel({
        loop: true,
        dots: true,
        dotsData: true,
        dotsEach: true,
        dotsContainer: '.product-preview-slide-owl-carousel-dot',
        nav: true,
        navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
        items: 1,
    });

    // modal image preview
    const owlProductImagePreview = $('.product-image-preview-modal__slider').owlCarousel({
        loop: true,
        dots: true,
        dotsData: true,
        dotsEach: true,
        dotsContainer: '.product-image-preview-modal__dots .list-dots',
        nav: true,
        navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
        items: 1,
    });
    owlProductImagePreview.on('changed.owl.carousel', function() {
        const elementOffset = $('.list-dots .owl-dot.active')[0].offsetLeft;
        const parentWidth = $(".product-image-preview-modal__dots").width();
        const scrollTo = elementOffset - (parentWidth / 2);
        $(".product-image-preview-modal__dots").animate({ scrollLeft: scrollTo }, 100);
    });

    $('[data-toggle="product-image-preview"],.product-image-preview-modal__close').on('click', function () {
            const selector = $(this).attr('data-target');
            $(selector).toggleClass('show');
        });
    // modal image preview
});
